import { render, staticRenderFns } from "./NomineeProgressBar.vue?vue&type=template&id=1621c1d5&scoped=true&"
import script from "./NomineeProgressBar.vue?vue&type=script&lang=js&"
export * from "./NomineeProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./NomineeProgressBar.vue?vue&type=style&index=0&id=1621c1d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1621c1d5",
  null
  
)

export default component.exports